import React from "react";
import { Link, useParams } from "react-router-dom";
import styles from "./Footer.module.css";

// ▼▼▼ 1. 翻訳データの定義 (11言語) ▼▼▼
const translations = {
  ja: {
    labelCompany: "運営会社",
    companyName: "株式会社KICKs",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    contact: "お問い合わせ",
    commercial: "特定商取引法に基づく表記",
  },
  en: {
    labelCompany: "Operating Company",
    companyName: "KICKs Inc.",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    contact: "Contact",
    commercial: "Legal Information",
  },
  zh: {
    labelCompany: "运营公司",
    companyName: "KICKs Inc.",
    privacy: "隐私政策",
    terms: "使用条款",
    contact: "联系我们",
    commercial: "特定商交易法",
  },
  tw: {
    labelCompany: "運營公司",
    companyName: "KICKs Inc.",
    privacy: "隱私權政策",
    terms: "使用條款",
    contact: "聯絡我們",
    commercial: "特定商交易法",
  },
  ko: {
    labelCompany: "운영 회사",
    companyName: "KICKs Inc.",
    privacy: "개인정보 처리방침",
    terms: "이용 약관",
    contact: "문의하기",
    commercial: "특정상거래법 표기",
  },
  fr: {
    labelCompany: "Société exploitante",
    companyName: "KICKs Inc.",
    privacy: "Politique de confidentialité",
    terms: "Conditions d'utilisation",
    contact: "Contact",
    commercial: "Mentions légales",
  },
  es: {
    labelCompany: "Empresa operadora",
    companyName: "KICKs Inc.",
    privacy: "Política de privacidad",
    terms: "Términos de uso",
    contact: "Contacto",
    commercial: "Información legal",
  },
  pt: {
    labelCompany: "Empresa operadora",
    companyName: "KICKs Inc.",
    privacy: "Política de Privacidade",
    terms: "Termos de Uso",
    contact: "Contato",
    commercial: "Informações legais",
  },
  th: {
    labelCompany: "บริษัทผู้ดำเนินงาน",
    companyName: "KICKs Inc.",
    privacy: "นโยบายความเป็นส่วนตัว",
    terms: "ข้อกำหนดการใช้งาน",
    contact: "ติดต่อเรา",
    commercial: "ข้อมูลทางกฎหมาย",
  },
  vi: {
    labelCompany: "Công ty vận hành",
    companyName: "KICKs Inc.",
    privacy: "Chính sách bảo mật",
    terms: "Điều khoản sử dụng",
    contact: "Liên hệ",
    commercial: "Thông tin pháp lý",
  },
  id: {
    labelCompany: "Perusahaan Operasional",
    companyName: "KICKs Inc.",
    privacy: "Kebijakan Privasi",
    terms: "Syarat Penggunaan",
    contact: "Kontak",
    commercial: "Informasi Hukum",
  },
};

const Footer = () => {
  // ▼▼▼ 2. 現在の言語を取得 ▼▼▼
  const { lang } = useParams();
  const currentLang = lang || "ja";
  
  // 翻訳データ取得 (未定義の場合は英語フォールバック)
  const t = translations[currentLang] || translations.en;

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        
        {/* 会社情報 */}
        <div className={styles.companyInfo}>
          <p className={styles.companyLabel}>
            {t.labelCompany}：<span className={styles.companyName}>{t.companyName}</span>
          </p>
          <a
            href="https://kanko-innovation.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.companyLink}
          >
            kanko-innovation.com
          </a>
        </div>

        {/* リンク集 */}
        <div className={styles.footerLinks}>
          {/* プライバシーポリシー・利用規約などは現状多言語ルートがない想定で固定リンクにしていますが、
              もし /privacy/en などがある場合は `to={`/privacy/${currentLang}`}` に変更してください */}
          <Link to="/privacy" className={styles.footerLink}>
            {t.privacy}
          </Link>
          <Link to="/terms" className={styles.footerLink}>
            {t.terms}
          </Link>
          {/* Contactは多言語対応済み */}
          <Link to={`/contact/${currentLang}`} className={styles.footerLink}>
            {t.contact}
          </Link>
          <Link to="/specifiedCommercialTransactionForToimap" className={styles.footerLink}>
            {t.commercial}
          </Link>
        </div>

        {/* コピーライト */}
        <div className={styles.copyright}>
          <p>© 2025 TOIMAP (KICKs, Inc.) All rights reserved.</p>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;